<forge-card [formGroup]="formGroup" telemetry="Card-BillingCycle-UtilityBilling" no-padding>
  <forge-toolbar fxLayout="column">
    <h2 slot="start" class="forge-typography--heading4">Billing Cycle Progress</h2>

    <lgd-select slot="center" controlName="billingCycle" label="Billing Cycle and Period" [suppressSupportText]="true"
      placeholder="Select a Billing Cycle and Period" [options]="billingCyclesObservable" style="width: 60%;">
    </lgd-select>

    <forge-icon-button slot="end">
      <forge-icon name="refresh" (click)="loadCycles()"
        aria-label="Refresh billing periods">
      </forge-icon>
      <forge-tooltip position="bottom">Refresh Billing Periods</forge-tooltip>
    </forge-icon-button>
  </forge-toolbar>

  <div fxLayout="column" fxLayoutAlign="space-between stretch"  class="metadata-padding">
    @if(!isLoaded) {
      <forge-linear-progress aria-label="Linear progress demo"></forge-linear-progress>
    }

    @if(!hasData) {
        <div>Not Enough Data to Display</div>
    }
    @else {
        <forge-stepper [selectedIndex]="selectedStep" (forge-step-select)="onStepSelect($event)">
          <forge-step>Meters</forge-step>
          <forge-step>Billing</forge-step>
          <forge-step>Past Due</forge-step>
        </forge-stepper>

        <forge-view-switcher [index]="selectedStep" style="margin-top: 1rem;">
          <forge-view name="Meters">
            <div class="stepper-header">
              @if(!isLinkable(meterReadingData) && selectedStep === 0) {
                <div>{{meterReadingData?.Title}}</div>
              }

              @if(isLinkable(meterReadingData) && selectedStep === 0) {
                <a (click)="launch(meterReadingData)" [attr.telemetry]="getAriaLabel(meterReadingData)" tabindex="0">
                  {{meterReadingData?.Title}}
                </a>
              }
            </div>

            <div fxLayout="row">
              @for (dataElement of meterReadingData?.DataElements ?? []; track dataElement) {
                <div fxFlex>
                  <labeled-field [label]="dataElement.Label">
                    <truncate-text [mainText]="dataElement.Value">
                    </truncate-text>
                  </labeled-field>
                </div>
              }
            </div>
          </forge-view>

          <forge-view name="Billing">
            <div class="stepper-header">
              @if(!isLinkable(billingData) && selectedStep === 1) {
                <div>
                  {{billingData?.Title}}
                </div>
              }

              @if(isLinkable(billingData) && selectedStep === 1) {
                <div (click)="launch(billingData)" [attr.telemetry]="getAriaLabel(billingData)">
                  {{billingData?.Title}}
                </div>
              }
            </div>

            <div fxLayout="row" layout-wrap>
              @for (dataElement of billingData?.DataElements ?? []; track dataElement) {
                <div fxFlex="auto">
                  <labeled-field [label]="dataElement.Label">
                    <truncate-text [mainText]="dataElement.Value">
                    </truncate-text>
                  </labeled-field>
                </div>
              }
            </div>
          </forge-view>

          <forge-view name="Past Due">
            @for (pastDueCard of pastDueData; track pastDueCard) {
              <div fxFlex="auto">
                <div class="stepper-header">
                  @if(!isLinkable(pastDueCard) && selectedStep === 2) {
                    <div>
                      {{pastDueCard?.Title}}
                    </div>
                  }
                  @if(isLinkable(pastDueCard) && selectedStep === 2) {
                    <a (click)="launch(pastDueCard)" [attr.telemetry]="getAriaLabel(pastDueCard)" tabindex="0">
                      {{pastDueCard?.Title}}
                    </a>
                  }
                </div>
                <div fxLayout="row" layout-wrap>
                  @for (dataElement of pastDueCard?.DataElements ?? []; track dataElement) {
                    @if (dataElement.Visible) {
                      <div fxFlex="auto">
                        <labeled-field [label]="dataElement.Label">
                          <truncate-text [mainText]="dataElement.Value">
                          </truncate-text>
                        </labeled-field>
                      </div>
                    }
                  }
                </div>
              </div>
            }
          </forge-view>
        </forge-view-switcher>
    }
  </div>
</forge-card>
